'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _rcTrigger = require('rc-trigger');

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

var _placements = require('./placements');

var _placements2 = _interopRequireDefault(_placements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ColorSet = 'ffffff,000000,eeece1,1f497d,4f81bd,c0504d,9bbb59,8064a2,4bacc6,f79646,\n  \'f2f2f2,7f7f7f,ddd9c3,c6d9f0,dbe5f1,f2dcdb,ebf1dd,e5e0ec,dbeef3,fdeada,\n  \'d8d8d8,595959,c4bd97,8db3e2,b8cce4,e5b9b7,d7e3bc,ccc1d9,b7dde8,fbd5b5,\n  \'bfbfbf,3f3f3f,938953,548dd4,95b3d7,d99694,c3d69b,b2a2c7,92cddc,fac08f,\n  \'a5a5a5,262626,494429,17365d,366092,953734,76923c,5f497a,31859b,e36c09,\n  \'7f7f7f,0c0c0c,1d1b10,0f243e,244061,632423,4f6128,3f3151,205867,974806,\n  \'c00000,ff0000,ffc000,ffff00,92d050,00b050,00b0f0,0070c0,002060,7030a0,'.split(',');
function noop() {}
function newArray(length, iterator) {
    if (Array.prototype.fill) {
        return new Array(length).fill(0).map(iterator);
    }
    return new Array(length).join('').split('').map(iterator);
}

var ColorPickerPanel = function (_React$Component) {
    _inherits(ColorPickerPanel, _React$Component);

    function ColorPickerPanel(props) {
        _classCallCheck(this, ColorPickerPanel);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this._canvas = {};
        _this.fillCanvasColor = function () {
            for (var color in _this._canvas) {
                if (_this._canvas.hasOwnProperty(color)) {
                    var canvas = _this._canvas[color];
                    if (canvas && !canvas.getAttribute('filled')) {
                        var ctx = canvas.getContext('2d');
                        ctx.fillStyle = color;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        _this._canvas[color].setAttribute('filled', true);
                    }
                }
            }
        };
        _this.reset = function () {
            _this.pickColor(_this.getDefaultColor(), true);
        };
        _this.onVisibleChange = function (open) {
            _this.setState({ open: open }, function () {
                if (open) {
                    _this.fillCanvasColor();
                    _reactDom2["default"].findDOMNode(_this.pickerPanelInstance).focus();
                }
            });
        };
        _this.renderColorPickerCell = function (color, idx) {
            var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var ele = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'li';

            var Ele = ele;
            return _react2["default"].createElement(
                Ele,
                { className: _this.props.prefixCls + '-color-picker-cell', key: idx },
                _react2["default"].createElement(
                    'a',
                    { tabIndex: 0, onMouseDown: function onMouseDown(e) {
                            _this.pickColor(color, true);e.preventDefault();
                        } },
                    _react2["default"].createElement('canvas', { className: _this.props.prefixCls + '-color-picker-celldiv', ref: function ref(ele) {
                            return _this._canvas[color] = ele;
                        } }),
                    text
                )
            );
        };
        _this.state = {
            currentColor: _this.getDefaultColor(props),
            open: false
        };
        _this._canvas = {};
        return _this;
    }

    ColorPickerPanel.prototype.getDefaultColor = function getDefaultColor() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return props.defaultColor || '#000';
    };

    ColorPickerPanel.prototype.pickColor = function pickColor(currentColor) {
        var closeModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        this.props.onChange ? this.props.onChange({ color: currentColor }) : null;
        this.setState({
            currentColor: currentColor,
            open: closeModal ? false : this.state.open
        });
    };

    ColorPickerPanel.prototype.getPickerElement = function getPickerElement() {
        var _this2 = this;

        if (!this._pickerElement) {
            this._pickerElement = _react2["default"].createElement(
                'div',
                { className: this.props.prefixCls + '-color-picker-panel', ref: function ref(ele) {
                        return _this2.pickerPanelInstance = ele;
                    } },
                _react2["default"].createElement(
                    'div',
                    { className: this.props.prefixCls + '-color-picker-color-auto', onMouseDown: this.reset },
                    _react2["default"].createElement(
                        'ul',
                        null,
                        this.renderColorPickerCell('#000', 0, '自动')
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: this.props.prefixCls + '-color-picker-first-row' },
                    _react2["default"].createElement(
                        'ul',
                        null,
                        newArray(10, function (_, idx) {
                            return _this2.renderColorPickerCell('#' + ColorSet[idx], idx + 1);
                        })
                    )
                ),
                _react2["default"].createElement(
                    'table',
                    null,
                    _react2["default"].createElement(
                        'tbody',
                        null,
                        newArray(5, function (_, row) {
                            return _react2["default"].createElement(
                                'tr',
                                { className: _this2.props.prefixCls + '-color-picker-compactrow', key: row },
                                newArray(10, function (_, idx) {
                                    return _this2.renderColorPickerCell('#' + ColorSet[idx + (row + 1) * 10], row * 10 + idx + 1, null, 'td');
                                })
                            );
                        })
                    )
                ),
                _react2["default"].createElement(
                    'span',
                    null,
                    '\u6807\u51C6\u989C\u8272'
                ),
                _react2["default"].createElement(
                    'div',
                    { className: this.props.prefixCls + '-color-picker-last-row' },
                    _react2["default"].createElement(
                        'ul',
                        null,
                        newArray(10, function (_, idx) {
                            return _this2.renderColorPickerCell('#' + ColorSet[idx + 60], idx + 1);
                        })
                    )
                )
            );
        }
        return this._pickerElement;
    };

    ColorPickerPanel.prototype.render = function render() {
        var _this3 = this;

        var _props = this.props,
            prefixCls = _props.prefixCls,
            placement = _props.placement,
            style = _props.style,
            getCalendarContainer = _props.getCalendarContainer,
            align = _props.align,
            animation = _props.animation,
            disabled = _props.disabled,
            transitionName = _props.transitionName;

        var children = this.props.children;
        if (children) {
            children = _react2["default"].cloneElement(children, {
                ref: function ref(ele) {
                    return _this3.triggerInstance = ele;
                },
                unselectable: true
            });
        }
        return _react2["default"].createElement(
            _rcTrigger2["default"],
            { popup: this.getPickerElement(), popupAlign: align, builtinPlacements: _placements2["default"], popupPlacement: placement, action: disabled ? [] : ['click'], destroyPopupOnHide: true, getPopupContainer: getCalendarContainer, popupStyle: style, popupAnimation: animation, popupTransitionName: transitionName, popupVisible: this.state.open, onPopupVisibleChange: this.onVisibleChange, prefixCls: prefixCls + '-color-picker' },
            children
        );
    };

    return ColorPickerPanel;
}(_react2["default"].Component);

exports["default"] = ColorPickerPanel;

ColorPickerPanel.defaultProps = {
    defaultColor: '#F00',
    defaultAlpha: 100,
    onChange: noop,
    onOpen: noop,
    onClose: noop,
    prefixCls: 'rc-editor',
    children: _react2["default"].createElement('span', { className: 'rc-color-picker-trigger' }),
    placement: 'topLeft',
    style: {}
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/FontColor/ColorPickerPanel.js
// module id = 211
// module chunks = 0 1 2